import { createSelector } from '@reduxjs/toolkit';
import { TStoreState } from 'redux/types';
import {
	TEuDdpVATReportData,
	TNewVATReportData,
	TNewVATReportFileTypes,
	TSwissPostVATReportData,
	TVATReportStore,
	TVatReportStatusData,
	TVatReportsResponsePayload,
} from './types';

// ==========================================:
const vatReportState = (state: TStoreState): TVATReportStore => state.vatreport;
export const getVatReport = createSelector(
	[vatReportState],
	(vatReport: TVATReportStore) => vatReport,
);

// ====================================================:
export const newVatReportIsLoad = createSelector(
	[getVatReport],
	(vatReport: TVATReportStore): boolean => vatReport.newFileLoader,
);

// ====================================================:
export const newVatReport = createSelector(
	[getVatReport],
	(vatReport: TVATReportStore): TNewVATReportData => vatReport.newFile,
);

// ====================================================:
export const vatReportStatusIsLoad = createSelector(
	[getVatReport],
	(vatReport: TVATReportStore): boolean => vatReport.vatReportStatusLoader,
);

// ====================================================:
export const vatReportStatus = createSelector(
	[getVatReport],
	(vatReport: TVATReportStore): TVatReportStatusData => vatReport.vatReportStatus,
);

// ====================================================:

export const newVatReportFileType = createSelector(
	[getVatReport],
	(vatReport: TVATReportStore): TNewVATReportFileTypes => vatReport.newFileType,
);

// ====================================================:

export const getVatReportsLoader = createSelector(
	[getVatReport],
	(vatReport: TVATReportStore): boolean => vatReport.vatReportsLoader,
);

// ====================================================:

export const getVatReports = createSelector(
	[getVatReport],
	(vatReport: TVATReportStore): TVatReportsResponsePayload => vatReport.vatReports,
);

// ====================================================:

export const getSwissPostVATReport = createSelector(
	[getVatReport],
	(vatReport: TVATReportStore): TSwissPostVATReportData => vatReport.swissPostVATReport,
);

// ====================================================:

export const getSwissPostVATReportLoader = createSelector(
	[getVatReport],
	(vatReport: TVATReportStore): boolean => vatReport.swissPostVATReportLoader,
);

// ====================================================:

export const getEuDdpVATReport = createSelector(
	[getVatReport],
	(vatReport: TVATReportStore): TEuDdpVATReportData => vatReport.euDdpVATReport,
);

// ====================================================:

export const getEuDdpVATReportLoader = createSelector(
	[getVatReport],
	(vatReport: TVATReportStore): boolean => vatReport.euDdpVATReportLoader,
);
